import { schemas } from '../generated/schema';

export { schemas };
export const Model = Object.keys(schemas).reduce((memo, key) => {
  const path = key.split('/');

  if (path[0] === 'Model') {
    return { ...memo, [path.slice(1).join('/')]: schemas[key] };
  }

  return memo;
}, {});
